import {createSlice} from "@reduxjs/toolkit";
import config from "../../config";

const customer = createSlice({
	name: "customer",
	initialState: {
		loading: false,
        error: null,
		items: [],
		filter:{
			page : 1,
			limit : config.api.limit,
		},
		pagination : {
			page : 1,
			limit : config.api.limit,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
            state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id === action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const customerActions = customer.actions;
//Reducers
export const customerReducer = customer.reducer;
//Selectors
export const customerItemsSelector = (state) => state.customer.items;
export const customerLoadingSelector = (state) => state.customer.loading;
export const customerErrorSelector = (state) => state.customer.error;
export const customerFilterSelector = (state) => state.customer.filter;
export const customerPaginationSelector = (state) => state.customer.pagination;